import { __rest } from "tslib";
import * as React from 'react';
import progressStyle from '@patternfly/react-styles/css/components/Progress/progress';
export const ProgressHelperText = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement("div", Object.assign({ className: progressStyle.progressHelperText }, props), children));
};
ProgressHelperText.displayName = 'ProgressHelperText';
//# sourceMappingURL=ProgressHelperText.js.map